import { getJSON, postJSON, deleteJSON } from "@/lib/api"
import type { UserFlags } from "@yomimono/types"

export const getUserFlags = async () => {
  const flags =
    await getJSON<{ name: string; value: boolean }[]>("/v1/user/flags")
  return flags.reduce(
    (acc, { name, value }) => ({ ...acc, [name]: value }),
    {}
  ) as UserFlags
}

export type UserProgress = {
  textbookId: string
  textbookTitle: string
  chapterId: string
  chapterNumber: number
  chapterTitle: string
}

export const getUserProgress = () =>
  getJSON<UserProgress | null>("/v1/user/progress")

export const setUserProgress = (data: {
  textbookId: string
  chapterNumber: number
}) => postJSON("/v1/user/progress", data)

export const deleteUser = () => deleteJSON("/v1/user")
